import AnswersItem from './AnswersItem'
import styles from './Answers.module.css'

function Answers() {
    const items = [
        {title: "Сколько хранятся пирожные макарон?", descr: "Срок хранения бла бла бла"},

        {
            title: "Как быстро мы выполняем заказы",
            descr: "Стандартный срок выполнения заказа 3-5 дней, При большом тираже и в предновогодний сезон может увеличиться. Потому что..."
        },

        {title: "А за 2 дня?", descr: "Текст про дополнительную стоимость при срочных заказах"},

        {
            title: "А с НДС работаете?",
            descr: "Для вашего удобства у нас есть два варианта взаимодействия: с НДС и без НДС. Всегда уточняйте форму оплаты у менеджера, чтобы получить максимально выгодные для вас условия!"
        },

        {
            title: "Что с доставкой?",
            descr: "Мы доставляем ваши заказы по всей России: от Камчатки до Калининграда, бережно упаковывая каждую печеньку или набор. Мы всегда производим для вас на 2-5% больше от заказанного количества, чтобы ничего не смогло омрачить результат нашей работы. Сроки доставки 2-7 дней с момента заказа."
        },

        {
            title: "Ещё вопрос",
            descr: "Как уже неоднократно упомянуто, сторонники тоталитаризма в науке освещают чрезвычайно интересные особенности картины в целом, однако конкретные выводы, разумеется, рассмотрены исключительно в разрезе маркетинговых и финансовых предпосылок."
        },
    ]
    return (
        <section className={styles.Answer}>
            <h2 className="titleSecond" style={{marginBottom: "33px"}}>Ответы на вопросы</h2>

            <div className={styles.AnswerItemsContainer}>
                {items.map((item) => {
                    return <AnswersItem title={item.title} descr={item.descr} key={item.title}/>
                })}
            </div>
        </section>
    )
}

export default Answers;